import React, { useState } from "react";
import Select from "react-select";
import { Card, CardBody, Container, FormGroup, Label } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";


// const BASE = "http://localhost/business_community/";
const BASE = "https://qnexus.in/community/";

const postTypeOptions = [
    { value: "TEXT", label: "Text Only" },
    { value: "IMAGE", label: "Image Post" },
    { value: "VIDEO", label: "Video Post" }
];

const CreatePost = () => {
    const dispatch = useDispatch();
    // Add this at the top of your component if you haven't already
    const profile = useSelector((state) => state.customer.customer?.user);
    const [content, setContent] = useState("");
    const [postType, setPostType] = useState(postTypeOptions[0]);
    const [mediaFile, setMediaFile] = useState(null);
    const [preview, setPreview] = useState(null);

    const handleMediaChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (postType.value === "IMAGE" && !file.type.startsWith("image/")) {
            toast.error("Please select an image file");
            return;
        }

        if (postType.value === "VIDEO" && !file.type.startsWith("video/")) {
            toast.error("Please select a video file");
            return;
        }

        setMediaFile(file);
        setPreview(URL.createObjectURL(file));
    };

    const submitPost = async () => {
        if (!content.trim()) {
            toast.error("Content is required");
            return;
        }

        if (postType.value !== "TEXT" && !mediaFile) {
            toast.error("Please upload media");
            return;
        }

        const formData = new FormData();
        formData.append("content", content);
        formData.append("post_type", postType.value);
        if (mediaFile) formData.append("media", mediaFile);

        dispatch(loadingTrue());
        try {
            const res = await Handler({
                method: "post",
                url: "/post/create.php",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" }
            });

            if (res?.success) {
                toast.success("Post created successfully");
                setContent("");
                setMediaFile(null);
                setPreview(null);
                setPostType(postTypeOptions[0]);
            } else {
                toast.error(res?.message || "Post failed");
            }
        } catch (e) {
            console.error(e);
            toast.error("Upload failed");
        }
        dispatch(loadingFalse());
    };

    const isTextOnly = postType.value === "TEXT";

    return (

        <Container className="create-post-container">
            <div className="header-section">
                <h2 >Create New Post</h2>
                <p>Share updates and media with your business community.</p>
            </div>

            <Card className="post-card">
                <CardBody className="post-card-body">

                    {/* LEFT COLUMN: MEDIA UPLOAD */}
                    <div className="media-upload-section">
                        <Label className="section-label">Post Media</Label>
                        <div className={`upload-box ${preview ? 'has-preview' : ''} ${isTextOnly ? 'upload-box-disabled' : ''}`}>
                            {preview ? (
                                <div className="preview-container">
                                    {postType.value === "IMAGE" && <img src={preview} alt="preview" className="img-fluid" />}
                                    {postType.value === "VIDEO" && <video src={preview} controls className="w-100" />}
                                    <label className="change-media-btn">
                                        <i className='bx bx-edit'></i> Change Media
                                        <input type="file" hidden onChange={handleMediaChange} />
                                    </label>
                                </div>
                            ) : (
                                <label className={`upload-placeholder ${isTextOnly ? 'not-clickable' : ''}`}>
                                    <i className='bx bx-cloud-upload'></i>
                                    <span>
                                        {isTextOnly ? "Media Disabled" : `Click to upload ${postType.label}`}
                                    </span>
                                    <small>
                                        {isTextOnly ? "Select Image/Video type to enable" : "JPG, PNG or MP4 supported"}
                                    </small>
                                    {/* Only render input if NOT text only */}
                                    {!isTextOnly && (
                                        <input type="file" hidden onChange={handleMediaChange} />
                                    )}
                                </label>
                            )}
                        </div>
                    </div>

                    {/* RIGHT COLUMN: CONTENT DETAILS */}
                    <div className="details-section">
                        <div className="post-profile-header mb-4">
                            <img
                                src={profile?.logo ? BASE + profile.logo : "https://ui-avatars.com/api/?name=B"}
                                alt="profile"
                                className="post-profile-img"
                            />
                            <div className="post-profile-info">
                                <h6 className="m-0">
                                    {/* Changed from business_name to name to match your database */}
                                    {profile?.name || "Business Name"}
                                </h6>
                                <small className="text-muted">
                                    {/* Displays the role or a default fallback */}
                                    {profile?.role ? `Posting as ${profile.role}` : "Posting as Seller & Vendor"}
                                </small>
                            </div>
                        </div>

                        <FormGroup>
                            <Label className="section-label">Post Type</Label>
                            <Select
                                options={postTypeOptions}
                                value={postType}
                                onChange={(selected) => {
                                    setPostType(selected);
                                    setMediaFile(null);
                                    setPreview(null);
                                }}
                                className="biz-select-container"
                                classNamePrefix="biz-select"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label className="section-label">What's on your mind?</Label>
                            <textarea
                                className="biz-textarea"
                                placeholder="Write your content here..."
                                value={content}
                                onChange={e => setContent(e.target.value)}
                            />
                        </FormGroup>

                        <div className="button-footer">
                            <button type="button" className="btn-save-draft">Save Draft</button>
                            <button type="button" className="btn-publish" onClick={submitPost}>
                                <i className='bx bx-send'></i> Publish Post
                            </button>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Container>

    );
};

export default CreatePost;